import Table from 'react-bootstrap/Table';
import { StellantisQuoteRequestDTO } from 'src/api/models/StellantisDTO';
import * as StellantisUtils from './stellantisUtils';
import _ from 'lodash';
import i18next from 'i18next';

type Props = {
  dto: StellantisQuoteRequestDTO;
}

const QuoteRequestDiff: React.FC<Props> = ({ dto }) => {
  const diff = StellantisUtils.quoteDiff(dto.request, dto.quote);

  if (_.isEmpty(diff)) return null;

  const keyLabelMap = {
    'marca': i18next.t('brand'),
    'modello': i18next.t('model'),
    'rcaPenaleRisarcitoria': i18next.t('liability_insurance'),
    'incendioFurtoScopertoPerc': i18next.t('theft_fire'),
    'kaskoFranchigia': i18next.t('kasko'),
    'gommeYN': i18next.t('tyres'),
    'tipoGomma': i18next.t('tipo_gomma'),
    'numTrenoGommeEstive': i18next.t('n_treno_gomme_estive'),
    'numTrenoGommeInvernali': i18next.t('n_treno_gomme_invernali'),
    'gommeIllimitateYN': i18next.t('gomme_illimitate_YN'),
    'autoSostitutivaYN': i18next.t('replacement_car'),
    'autoSostitutivaGruppo': i18next.t('auto_sostitutiva_gruppo'),
    'tipoCliente': i18next.t('client_type'),
    'nome': i18next.t('first_name'),
    'cognome': i18next.t('last_name'),
    'ragioneSociale': i18next.t('company'),
    'kmAnnui': i18next.t('km_annui'),
    'durata': i18next.t('duration_months'),
    'anticipoNoIva': i18next.t('downpayment'),
    'requestNote': i18next.t('notes'),
    'optionals': i18next.t('optionals'),
  };

  return (
    <Table >
      <thead>
        <tr>
          <th>{i18next.t('diff_field')}</th>
          <th>{i18next.t('diff_old_value')}</th>
          <th>{i18next.t('diff_new_value')}</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(diff).map(key => {
          return (
            <tr key={key}>
              <td>{keyLabelMap[key]}</td>
              <td style={{ whiteSpace: 'pre-wrap' }}>{diff[key].oldValue}</td>
              <td style={{ whiteSpace: 'pre-wrap' }}>{diff[key].newValue}</td>
            </tr>)
        })}
      </tbody>
    </Table>
  );
}


export default QuoteRequestDiff;
